var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgIcon15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 35,
    viewBox: "0 0 186 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_266_1458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7557 9.24152C58.8691 8.35872 60.9824 8.04702 62.7786 8.30644C67.9565 9.13746 68.9602 15.1617 64.9979 21.7054C60.9824 28.1972 53.5855 32.8711 48.4076 31.9883C46.4526 31.6766 45.0785 30.5862 44.3393 28.9759C44.2865 28.8724 44.2865 28.8201 44.2337 28.7688L44.1282 29.0282C45.0258 31.9365 47.3507 34.0138 50.9963 34.585C58.2348 35.779 67.9043 30.4821 72.5008 22.8476C77.0973 15.213 74.984 8.04653 67.6927 6.79975C64.2586 6.22864 60.2959 7.05966 56.5447 8.98112L56.7562 9.24103L56.7557 9.24152Z",
    fill: "url(#paint0_linear_266_1458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8834 25.8362C53.7701 26.7225 51.6568 27.0351 49.8601 26.7747C44.6826 25.9408 43.6785 19.8943 47.6408 13.3265C51.6568 6.81149 59.0531 2.12029 64.2316 3.00605C66.1861 3.31923 67.5601 4.41361 68.2999 6.02929C68.3527 6.13385 68.3527 6.18564 68.4054 6.23791L68.511 5.97751C67.6129 3.05833 65.288 0.973628 61.6424 0.400051C54.3511 -0.798395 44.7354 4.46589 40.1389 12.1281C35.5424 19.7902 37.6552 26.9829 44.9465 28.1818C48.381 28.7554 52.3433 27.9214 56.095 25.9925L55.8834 25.8362Z",
    fill: "url(#paint1_linear_266_1458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35579 25.0353H31.9361C31.9361 26.5035 31.4118 27.7616 30.3638 28.7574C29.3158 29.7536 28.1109 30.2779 26.696 30.2779H5.73548C4.26775 30.2779 3.01013 29.7536 2.01438 28.7574C1.01962 27.7088 0.495361 26.5035 0.495361 25.0353V9.30801C0.495361 7.84028 1.01962 6.63493 2.01487 5.58592C3.01111 4.58968 4.26874 4.06592 5.73548 4.06592H26.696C28.1114 4.06592 29.369 4.59018 30.3643 5.58592C31.4123 6.58216 31.9366 7.84028 31.9366 9.30801H8.35579C7.62192 9.30801 6.99311 9.57038 6.46934 10.0424C5.99736 10.5666 5.73548 11.1954 5.73548 11.9293V22.4145C5.73548 23.1483 5.99736 23.7771 6.46934 24.3014C6.99311 24.8257 7.62192 25.0353 8.35579 25.0353ZM162.353 25.0353H185.934C185.934 26.5035 185.41 27.7616 184.362 28.7574C183.314 29.7536 182.109 30.2779 180.694 30.2779H159.733C158.266 30.2779 157.008 29.7536 156.012 28.7574C155.017 27.7088 154.493 26.5035 154.493 25.0353V9.30801C154.493 7.84028 155.017 6.63493 156.012 5.58592C157.008 4.58968 158.266 4.06592 159.733 4.06592H180.693C182.109 4.06592 183.366 4.59018 184.362 5.58592C185.41 6.58216 185.934 7.84028 185.934 9.30801H162.353C161.619 9.30801 160.99 9.57038 160.467 10.0424C159.995 10.5666 159.733 11.1954 159.733 11.9293V22.4145C159.733 23.1483 159.995 23.7771 160.467 24.3014C160.99 24.8257 161.619 25.0353 162.353 25.0353ZM90.5943 30.2779V9.30801H82.7344C81.2672 9.30801 80.0095 8.78375 79.0138 7.788C78.018 6.73949 77.4943 5.53414 77.4943 4.06592H108.935C108.935 5.53364 108.411 6.79177 107.363 7.788C106.315 8.78424 105.11 9.30801 103.695 9.30801H95.8349V30.2779H90.5943ZM119.309 9.81944C117.841 9.81944 116.584 9.30801 115.588 8.33643C114.592 7.31356 114.069 6.13681 114.069 4.70509H145.509C145.509 6.13731 144.986 7.36485 143.938 8.33643C142.889 9.30801 141.684 9.81944 140.269 9.81944H119.309ZM115.352 18.0537C115.508 18.2589 115.664 18.4123 115.82 18.5656C116.808 19.5372 118.056 20.0486 119.511 20.0486H140.31C141.714 20.0486 142.91 19.5372 143.95 18.5656C144.989 17.5941 145.51 16.366 145.51 14.9343H115.352V18.0542V18.0537Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.352 18.0537V25.1635C115.352 26.5953 115.876 27.7715 116.871 28.7949C117.867 29.7665 119.125 30.2779 120.592 30.2779H141.552C142.968 30.2779 144.173 29.7665 145.221 28.7949C146.269 27.8233 146.793 26.5953 146.793 25.1635H123.212C122.478 25.1635 121.85 24.9076 121.325 24.4474C120.854 23.936 120.592 23.322 120.592 22.6059V14.9343H115.352V18.0542V18.0537Z",
    fill: "#6C6C6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_266_1458",
    x1: 44.1282,
    y1: 20.6878,
    x2: 74.9278,
    y2: 20.6878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00271,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3384,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7272,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8844,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9B9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_266_1458",
    x1: 53.1113,
    y1: 0.191724,
    x2: 53.1113,
    y2: 28.3562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4072,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6637,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B7B7B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_266_1458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185.439,
    height: 34.5231,
    fill: "white",
    transform: "translate(0.495361 0.22998)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIcon15);
export default __webpack_public_path__ + "static/media/img-icon-15.cb344902ba4cfcc38b423355e03b6549.svg";
export { ForwardRef as ReactComponent };